import { render, staticRenderFns } from "./authoriseReversal.vue?vue&type=template&id=45ab746f&"
import script from "./authoriseReversal.vue?vue&type=script&lang=js&"
export * from "./authoriseReversal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports